import { render, staticRenderFns } from "./PropertiesModal.vue?vue&type=template&id=bd8ed9f8&scoped=true"
import script from "./PropertiesModal.vue?vue&type=script&lang=js"
export * from "./PropertiesModal.vue?vue&type=script&lang=js"
import style0 from "./PropertiesModal.vue?vue&type=style&index=0&id=bd8ed9f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd8ed9f8",
  null
  
)

export default component.exports